// @flow
import gqlClient from 'Utils/graphql-client/graphqlClient';
import { STATE_PRODUCT_ALL_INCLUSIVE_SERVICES } from 'Utils/request/requestDictionary';
import { buildArgs } from 'Utils/graphql';

export type AllInclusiveServicesCriteria = {
  accommodationId: string,
  accommodationLabel: string,
  productId: string,
  includesTransportation: boolean,
  includesChildcare: boolean,
};

export type AllInclusiveServicesData = Array<{
  label: string,
  icon: string,
  description?: string,
  type: string,
}>;

export const fetchAllInclusiveServices = (
  appContext: AppContext,
  criteria: AllInclusiveServicesCriteria,
): Promise<{ fetchAllInclusiveServices: AllInclusiveServicesData }> => {
  const allInclusiveServicesArgs = buildArgs(criteria);
  const query = `query {
      allInclusiveServices(${allInclusiveServicesArgs}) {
        label
        description
        icon
        type
      }
    }
  `;
  return gqlClient.runQuery(query, appContext, {
    requestName: STATE_PRODUCT_ALL_INCLUSIVE_SERVICES,
  });
};
